export default __webpack_public_path__ + "static/media/locatorTheme.669ff7a6.png";